import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { normalizeLanguage } from "@/constants/i18n";

function syncDocumentLanguage(language: string | null | undefined): void {
  document.documentElement.lang = normalizeLanguage(language);
}

export function useDocumentLanguage(): void {
  const { i18n } = useTranslation();

  useEffect(() => {
    syncDocumentLanguage(i18n.resolvedLanguage ?? i18n.language);
  }, [i18n.language, i18n.resolvedLanguage]);
}
